export default "<app-header [url]=\"url\"></app-header>\n<router-outlet></router-outlet>\n<app-footer class=\"mt-auto\"></app-footer>\n\n"